import {
  hackPaths,
  hackRoutes,
} from "@/mixin/parents-attach-first-child-config";
import Vue from "vue";

const mixin = {
  data() {
    return {
      theme: {
        colors: {
          cyan: "#c9e8f4",
          earth: "#fae6d2",
        },
      },
    };
  },
  methods: {
    /**
     * 获取schema path 值
     * 该值兼容了, 父阶段和子阶段 路由名
     * 如果当前是阶段, 则会返回第一个子阶段
     * @returns {string}
     */
    get_schema_path(path) {
      return hackPaths[path] ?? path;
    },
    /**
     * 获取路由 name 值
     * 该值兼容了, 父阶段和子阶段 路由名
     * 如果当前是阶段, 则会返回第一个子阶段
     * @returns {string}
     */
    get_router_name(name) {
      name = name ?? this.$route.name;
      return hackRoutes[name] ?? name;
    },
  },
};

Vue.mixin(mixin);
